import axios from '../plugins/parseAxios'
export class ContractCheckoutAPI {
    static getContractCheckout(payload) {
        return axios.post('functions/getContractCheckout', payload)
    }
    static getContractCheckoutsBetweenDateByMarket(payload) {
        return axios.post('functions/getContractCheckoutsBetweenDateByMarket', payload)
    }
    static getContractCheckoutsStatusDateBetweenDateByMarket(payload) {
        return axios.post('functions/getContractCheckoutsStatusDateBetweenDateByMarket', payload)
    }
    static getContractCheckoutData(payload) {
        return axios.post('functions/getContractCheckoutData', payload)
    }
    static createContractCheckout(payload) {
        return axios.post('functions/createContractCheckout', payload)
    }
    static sendContractCheckoutApproveTask(payload) {
        return axios.post('functions/sendContractCheckoutApproveTask', payload)
    }
    static cancelDraftContractCheckout(payload) {
        return axios.post('functions/cancelDraftContractCheckout', payload)
    }
    static getContractCheckoutsByContract(payload) {
        return axios.post('functions/getContractCheckoutsByContract', payload)
    }
    static payContractCheckout(payload) {
        return axios.post('functions/payContractCheckout', payload)
    }
    static successContractCheckout(payload) {
        return axios.post('functions/successContractCheckout', payload)
    }
    static cancelContractCheckOutInvoicePayment(id) {
        return axios.post("functions/cancelContractCheckOutInvoicePayment", {
            id
        });
    }
    static updateContractCheckout(payload) {
        return axios.post('functions/updateContractCheckout', payload)
    }
    static clearDebtContractCheckout(id) {
        return axios.post("functions/clearDebtContractCheckout", {
            id
        });
    }
    static getContractCheckoutByContractIds(payload) {
        return axios.post('functions/getContractCheckoutByContractIds', payload)
    }
}